import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau1 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-7395">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-7396"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-7397">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-7398">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-7399">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-7400">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-7401">
          <div className="text-left" data-id="element-7402">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-7403">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-7404">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-7405">
        <div className="max-w-4xl mx-auto" data-id="element-7406">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-7407">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-7408">
            When GLP-1 Weight Loss Stalls: It's Not A Plateau. It's A "Safety
            Stop." Why Your Body Has Paused Weight Loss (And How To Signal The
            "All Clear").
          </h1>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-7409">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-7410">
              <img src="https://cdn.magicpatterns.com/uploads/rKaFbUnFVbMoxdhGqaKtZu/YOBfxHJfIQlDu4JngMJH0_HjPwLyqE.png" alt="Dr. Thomas Reed" className="w-full h-full object-cover" data-id="element-7411" />
            </div>
            <div className="flex-1" data-id="element-7412">
              <div className="flex items-center gap-2 mb-2" data-id="element-7413">
                <span className="text-base font-medium text-gray-900" data-id="element-7414">
                  Written by Dr. Thomas Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-7415" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-7416">
                Verified Metabolic Health Specialist
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-7417">
                <div className="flex items-center gap-1" data-id="element-7418">
                  <ClockIcon className="h-4 w-4" data-id="element-7419" />
                  <span data-id="element-7420">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-7421">
                  <EyeIcon className="h-4 w-4" data-id="element-7422" />
                  <span data-id="element-7423">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6" data-id="element-7424">
            
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-7425">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance—it has hit a "stress
            threshold." Here is how to lower your biological threat level to
            restart fat burning without changing your prescription.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-7426">
            <div className="mb-1 flex items-center" data-id="element-7427">
              <span className="font-medium mr-2" data-id="element-7428">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-7429">
              <span className="font-medium mr-2" data-id="element-7430">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau1;